import { defineComponent as _defineComponent } from 'vue'
import { prop } from 'ramda'
import { reactive, computed, ref, watch } from 'vue'
import { $vfm } from 'vue-final-modal'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductOrder',
  props: {
  productId: {
    type: [String, Number],
  },
  productType: {
    type: String,
  },
  maxQuantity: {
    type: Number,
  },
  minQuantity: {
    type: Number,
  },
  needConvertArea: {
    type: Boolean,
  },
  inStock: {
    type: Boolean,
  },
  quantityInBox: {
    type: Number,
  },
  quantityMaxBatch: {
    type: Number,
  },
  price: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const maxQuantityInBox = props.quantityInBox * props.maxQuantity
const batchRemainder = (props.quantityMaxBatch - maxQuantityInBox).toFixed(1)

const pricewith_batches = computed(() => {
  const price = props.price.replace(',', '.')
  return Number(price) * Number(batchRemainder)
})

const isFullQuantityInBox = computed(() => {
  return formdata.quantity === props.maxQuantity || props.quantityMaxBatch < props.quantityInBox
})
const openFeedBackForm = () => {
  $vfm.show({
    component: 'UiModalContainer',
  }, {
    classes: ['modal--size_xl'],
    component: 'Modals/Common/ModalFeedback',
  })
}

const formdata = reactive({
  quantity: props.minQuantity || 1,
  quantityInBox: props.quantityInBox,
  with_batches: false,
})

// watch(() => formdata.with_batches, () => {
//   if(!props.inStock) formdata.quantity = 0
// }, { deep: true })

const quantityInBoxChangeHandler = () => {
  formdata.quantity = Math.round(Number(formdata.quantityInBox) / props.quantityInBox)
}

const quantityChangeHandler = () => {
  if (!props.needConvertArea) return

  formdata.quantityInBox = Number((Number(formdata.quantity) * props.quantityInBox).toFixed(2))
}

const totalPrice = computed(() => {
  if (!props.needConvertArea) return 0

  const price = props.price.replace(',', '.')
  if (formdata.with_batches) return Number(price) * Number(formdata.quantityInBox) + pricewith_batches.value
  return Number(price) * Number(formdata.quantityInBox)
})

const __returned__ = { props, maxQuantityInBox, batchRemainder, pricewith_batches, isFullQuantityInBox, openFeedBackForm, formdata, quantityInBoxChangeHandler, quantityChangeHandler, totalPrice, get prop() { return prop }, reactive, computed, ref, watch, get $vfm() { return $vfm } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})